if (window.matchMedia('(min-width: 769px)').matches) {
  let target = document.querySelectorAll('.js-sideNav .c-sideNav__item');
}